import React, { useEffect, useState, useContext } from 'react'
import { Button } from '@material-ui/core'
import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import CustomContext from '@/custom/context/custom/customContext'
import { Link, useParams, useHistory } from 'react-router-dom'
import * as Yup from 'yup'
import {
    Checkbox,
    FormControlLabel,
    FormControl,
    RadioGroup,
    TextField,
    Radio,
    MenuItem,
} from '@material-ui/core'
import EMDSelectionComponent from './EMDSelectionComponent'
import PaymentMethodComponent from './PaymentMethodComponent'
import './Checkout.css'
import { handleRedirectInternal } from '@/product/common/components'
import AuthContext from '@/product/context/auth/authContext'
import SignContext from '@/custom/context/signContext'

const Checkout = (props) => {
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('offline')
    const [auction, setAuction] = useState({})
    const [list, setList] = useState([])

    const authContext = useContext(AuthContext)
    // const handleRedirectInternal = (path) => {
    //     history.push(`/${path}`)
    //     window.scrollTo(0, 0)
    // }

    const { loginPopup, handleLoginPopup, kycPopup, handleKycPopup, handleBusign } =
        useContext(SignContext)
    const { user, isAuthenticated } = authContext
    const [flag, setFlag] = useState(0)
    const [offlinePaymentDetails, setOfflinePaymentDetails] = useState({
        paymentMode: 'Bank Transfer',
        bankName: '',
        branchName: '',
        referenceNo: '',
        paymentProof: null,
    })

    const formikPreference = useFormik({
        initialValues: {
            pay_auction: [],
        },
        onSubmit: (values) => {
            console.log('Updated Preferences:', values)
        },
    })
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const customContext = useContext(CustomContext)
    const {
        getEmdListForAuction,
        auction_emd_list,
        cashFreeEmdPayment,
        responseStatus,
        clearResponse,
        payCartsOfflineEmd,
    } = customContext
    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'generate_link_cashfree') {
                if (responseStatus.status === 'success') {
                    window.open(responseStatus.data.url, '_self')
                }
            } else if (responseStatus.from === 'payCartsOfflineEmd') {
                setAlert(
                    responseStatus.status === 'success'
                        ? 'Payment submitted for verification'
                        : 'Something went wrong',
                    responseStatus.status || 'error',
                )
                if (responseStatus.status === 'success') {
                    handleRedirectInternal(history, `liveAuction/${props.match.params.auction_id}`)
                }
            }
            clearResponse()
        }
    }, [responseStatus])
    const history = useHistory()
    const validationArray = Yup.object({
        termCheck: Yup.boolean().oneOf([true], 'Please accept terms and condition'),
        payment_method: Yup.string().required('Required'),
        // proof_of_payment: Yup.string().when('payment_type', {
        //     is: 1,
        //     then: Yup.string().required('Proof is required for offline payments'),
        //     otherwise: Yup.string().notRequired(),
        // }),
        proof_of_payment: Yup.array().when(['payment_type'], {
            is: (payment_type) => payment_type == 1,
            then: Yup.array()
                .min(1, 'Payment Proof is required')
                .required('Proof of payment is required'),
            otherwise: Yup.array().notRequired(),
        }),
        bank_name: Yup.string().when(['payment_method', 'payment_type'], {
            is: (payment_method, payment_type) =>
                (payment_method == 'cheque' ||
                    payment_method == 'dd' ||
                    payment_method == 'rtgs' ||
                    payment_method == 'neft') &&
                payment_type == 1,
            then: Yup.string().required('Bank name is required '),
            otherwise: Yup.string().notRequired(),
        }),
        branch: Yup.string().when(['payment_method', 'payment_type'], {
            is: (payment_method, payment_type) =>
                (payment_method == 'cheque' ||
                    payment_method == 'dd' ||
                    payment_method == 'rtgs' ||
                    payment_method == 'neft') &&
                payment_type == 1,
            then: Yup.string().required('Branch name is required '),
            otherwise: Yup.string().notRequired(),
        }),
        actual_transaction_reference_number: Yup.string().when(['payment_method', 'payment_type'], {
            is: (payment_method, payment_type) =>
                (payment_method == 'cheque' ||
                    payment_method == 'dd' ||
                    payment_method == 'rtgs' ||
                    payment_method == 'neft') &&
                payment_type == 1,
            then: Yup.string().required('Branch name is required '),
            otherwise: Yup.string().notRequired(),
        }),
        dd_in_favour_of: Yup.string().when(['payment_method', 'payment_type'], {
            is: (payment_method, payment_type) => payment_method == 'dd' && payment_type == 1,
            then: Yup.string().required('Branch name is required '),
            otherwise: Yup.string().notRequired(),
        }),
    })

    const formikPayment = useFormik({
        initialValues: {
            emd_config_id: [],
            payment_method: 'cash',
            payment_type: 1,
            termCheck: false,
            pay_type: 'access',
            bank_name: '',
            payment_lot_ids: [],
            branch: '',
            proof_of_payment: [],
            actual_transaction_reference_number: '',
            dd_in_favour_of: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            console.log('Updated Preferences:', values)
            values.auction_id = props.match.params.auction_id
            if (!values.payment_lot_ids.length) {
                setAlert('Please choose EMD amount for payment', 'error')
                return ''
            }
            if (flag && values.payment_lot_ids.length) {
                if (values.payment_lot_ids.includes(flag) && values.payment_lot_ids.length > 1) {
                    setAlert('Please choose either entire auction or individual lot ids', 'error')
                    return ''
                }
            }
            if (values.payment_type == 1) {
                payCartsOfflineEmd(values)
            } else if (values.payment_type == 3) {
                cashFreeEmdPayment(values)
            } else {
                handleRedirectInternal(history, 'wallet')
            }
        },
    })

    useEffect(() => {
        if (props.match.params.auction_id) {
            getEmdListForAuction(
                { auction_id: props.match.params.auction_id },
                props.match.params.auction_id,
            )
        }
    }, [props.match.params.auction_id])
    useEffect(() => {
        if (auction_emd_list) {
            if (user && !user.is_kyc_done) {
                handleKycPopup()
            } else if (user && user.initial_bu_status != 2) {
                setAlert('Please sign BU doc', 'error')
                handleRedirectInternal(history, `bidderSign`)
            } else if (auction_emd_list.from == props.match.params.auction_id) {
                if (auction_emd_list.records && auction_emd_list.records.length) {
                    let flagCheck = auction_emd_list.records?.find(
                        (ele) => ele.is_entire_auction == 1,
                    )
                    setFlag(flagCheck && flagCheck.id ? flagCheck.id.toString() : 0)
                    setAuction(auction_emd_list.records.length ? auction_emd_list.records[0] : {})
                    setList(auction_emd_list.records || [])
                } else {
                    setAlert('EMD not created. Try again later.', 'error')
                    handleRedirectInternal(history, `liveAuction/${props.match.params.auction_id}`)
                }
            } else {
                setAuction({})
                setList([])
            }
        }
    }, [auction_emd_list, user])

    const handleChange = (event) => {
        const { value, checked } = event.target
        const updatedSelection = checked
            ? [...formikPreference.values.payment_lot_ids, value]
            : formikPreference.values.payment_lot_ids.filter((id) => id !== value)

        formikPreference.setFieldValue('payment_lot_ids', updatedSelection)
        formikPreference.submitForm()
    }

    const handleOfflinePaymentChange = (e) => {
        const { name, value } = e.target
        setOfflinePaymentDetails((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    const handleFileUpload = (e) => {
        setOfflinePaymentDetails((prev) => ({
            ...prev,
            paymentProof: e.target.files[0],
        }))
    }

    const handlePaymentSubmit = () => {
        if (selectedPaymentMethod === 'offline') {
            if (!offlinePaymentDetails.bankName || !offlinePaymentDetails.referenceNo) {
                alert('Please fill all required fields for offline payment')
                return
            }
            console.log('Submitting offline payment:', offlinePaymentDetails)
        } else if (selectedPaymentMethod === 'wallet') {
            console.log('Processing wallet payment')
        } else {
            console.log('Processing online payment')
        }
    }

    const options = [
        {
            id: 4135,
            label: 'Select to pay for entire auction',
            payable: '₹ 1000000.00',
            auctionId: '4135',
            remainPayable: '₹ 500.00',
            startDateTime: '20-03-2025, 05:19 PM',
        },
    ]

    return (
        <div className="checkoutParent">
            <EMDSelectionComponent
                formik={formikPayment}
                list={list}
                auction={auction}
                flag={flag}
                formikPreference={formikPreference}
                handleChange={handleChange}
            />
            <PaymentMethodComponent
                formik={formikPayment}
                list={list}
                selectedPaymentMethod={selectedPaymentMethod}
                setSelectedPaymentMethod={setSelectedPaymentMethod}
                offlinePaymentDetails={offlinePaymentDetails}
                handleOfflinePaymentChange={handleOfflinePaymentChange}
                handleFileUpload={handleFileUpload}
                handlePaymentSubmit={handlePaymentSubmit}
            />
        </div>
    )
}

export default Checkout
